import { DatabaseOutlined } from "@ant-design/icons";
import { useMemo } from "react";

import InstanceLabel from "components/Atoms/Datastores/InstanceLabel";
import DatastoreLabel from "components/Atoms/Datastores/DatastoreLabel";
import DatastoreIcon from "components/Atoms/Icon/DatastoreIcon";

import { createItem } from "lib/createItem";

import { maybeMissing } from "utils/data/validate";
// import response from "./response.json";
import { useDatastoreStore } from "hooks/datastores/useDatastoresStore";

export const useDatastoresFromType = (type?: string) => {
  const isLoading = useDatastoreStore((s) => s.loading);
  const datastoresFromType = useDatastoreStore(
    (s) => s.datastoresFromType[type ?? ""]
  );

  const datastores = useMemo(() => {
    if (isLoading) return [];
    return datastoresFromType;
  }, [datastoresFromType, isLoading]);

  return {
    datastores,
    isLoading,
  };
};

export const useDatastoresFromTypes = (types: string[]) => {
  // const { isDemo } = useContext(DemoContext);
  const isLoading = useDatastoreStore((s) => s.loading);
  const datastoresFromType = useDatastoreStore((s) => s.datastoresFromType);

  const datastore_items = useMemo(() => {
    if (isLoading || !datastoresFromType) return [];

    const entries = Object.entries(datastoresFromType).map(
      ([type, typeData]) => {
        return [
          type,
          typeData.map(({ name, id }) => {
            const label = (
              <InstanceLabel
                name={maybeMissing(name)}
                category={maybeMissing(type)}
              />
            );

            const icon = (
              <DatabaseOutlined className="text-[12px] flex items-center" />
            );
            return createItem(label, `${type}-${id}`, icon);
          }),
        ];
      }
    );

    return Object.fromEntries(entries);
  }, [datastoresFromType, isLoading]);

  const datastores = useMemo(() => {
    return types.map((type) => {
      const icon = <DatastoreIcon type={type} width={25} height={25} />;
      const label = <DatastoreLabel name={type} />;
      const children = datastore_items[type];

      return createItem(label, type, icon, children);
    });
  }, [datastore_items, types]);

  return { datastores, isLoading };
};
